"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewCallbackBannerDesktop = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./style.css"));
var _CallbackForm = require("../CallbackForm");
var _PersonalAgreement = require("../PersonalAgreement");
var _clsx = _interopRequireDefault(require("clsx"));
var _NewBannerText = require("../NewBannerText");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NewCallbackBannerDesktop = _ref => {
  let {
    personalAgreementLink,
    onSubmit,
    phone,
    onPhoneChange,
    loading,
    error,
    placeType
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: style['banner']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['info']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['info-text']
  }, /*#__PURE__*/React.createElement(_NewBannerText.NewBannerText, {
    isCallback: true
  })), /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(placeType === 'card' && style['form'])
  }, /*#__PURE__*/React.createElement(_CallbackForm.CallbackForm, {
    onClick: onSubmit,
    phone: phone,
    onChange: onPhoneChange,
    submitting: loading,
    personalAgreement: /*#__PURE__*/React.createElement(_PersonalAgreement.PersonalAgreement, {
      url: personalAgreementLink,
      theme: "dark"
    }),
    error: error
  }))), /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(style['image'], style[`image--${placeType}`])
  }));
};
exports.NewCallbackBannerDesktop = NewCallbackBannerDesktop;